import { Injectable } from '@angular/core';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import {
  CryptoJointOfferRenewalEncryption,
  GetCodeGeneratorEntity,
} from '../configs/entity.config';
import { TranslationService } from '@proximus/ng-common';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CryptoService {
  private encryptionKey;
  constructor(private translationService: TranslationService) {
    this.encryptionKey = this.translationService.getTranslatedValueFor(
      'products.card.jointOffer.crypto.encryptionKey',
    );
  }

  encryptMessage(msisdn: string[]) {
    const iEntity = EntityManager.createEntity(
      CryptoJointOfferRenewalEncryption,
      {
        encryptionKey: this.encryptionKey,
      },
    );
    iEntity.value = msisdn;
    return EntityManager.saveEntity(iEntity);
  }

  codeGenerator(payload: unknown): Observable<string> {
    const iEntity = EntityManager.createEntity(GetCodeGeneratorEntity, {});
    iEntity.value = payload;
    return EntityManager.saveEntity(iEntity).pipe(
      map((entityResponse: IEntity<{ token: string }>) => entityResponse.value),
      filter((value) => value != null),
      map((value) => value.token),
    );
  }
}
